<template>
	<v-layout row wrap v-if="(actionName !== otherActionName) || !old || !otherActionName">
		<v-flex d-flex xs12>
			<v-card>
				<v-card :color="color">
					<v-card-text class="px-2"><strong>{{serialNumber}} &emsp; {{actionName}} {{status}}</strong>
					</v-card-text>
				</v-card>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
	import {FinalReportComparisonUtils} from "./Utils/FinalReportComparisonUtils";

	export default {
		name: "finalReportComparisonAction",

		props: {
			serialNumber: {},

			actionName: {},
			otherActionName: {},

			costs: {},
			otherCosts: {},

			old: Boolean

		},

    beforeMount() {
      let comparisonResult = JSON.stringify(this.costs) === JSON.stringify(this.otherCosts)
          && this.actionName === this.otherActionName;
      if (comparisonResult === false) {
        this.$emit('dataDiffer');
      }
    },

		computed: {
			color () {
				return FinalReportComparisonUtils.comparisonColor(this.status, -2);
			},

			status () {
				return FinalReportComparisonUtils.getComparisonStatusAction(
					this.actionName,
					this.otherActionName,
					this.costs,
					this.otherCosts,
					this.old);
			}
		}
	};
</script>

<style scoped>

</style>